var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfort4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4613_25780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4613_25780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 55L15 51.5L32.25 34.1875L41 42.9375L53.9375 30L57.5 33.5625L41 50L32.25 41.25L18.5 55ZM10 52.5C8.625 52.5 7.44792 52.0104 6.46875 51.0312C5.48958 50.0521 5 48.875 5 47.5V12.5C5 11.125 5.48958 9.94792 6.46875 8.96875C7.44792 7.98958 8.625 7.5 10 7.5H45C46.375 7.5 47.5521 7.98958 48.5312 8.96875C49.5104 9.94792 50 11.125 50 12.5V23H10V52.5ZM10 18H45V12.5H10V18Z",
    fill: "#FF595E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfort4);
export default __webpack_public_path__ + "static/media/transfort4.0f9edfd202e75a9a595829440bd8a9c8.svg";
export { ForwardRef as ReactComponent };